<template>
  <button
    class="c-product-info__width__button"
    @click="handleClick"
  >
    <slot />
  </button>
</template>

<script>
import get from 'lodash/get'
import isObject from 'lodash/isObject'
import isString from 'lodash/isString'
export default {
  props: {
    to: {
      type: [String, Object],
      required: true
    }
  },
  methods: {
    handleClick() {
      const to = this.to
      let result = null
      if (isString(to)) {
        result = to.replace('/product/', '')
      } else if (isObject(to)) {
        result = get(to, 'productHandle') || get(to, 'handle')
      }
      if (result) {
        this.$emit('update:width', result)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.c-product-info__width__button {
  @include buttonReset;
}
</style>
